<template>
  <!-- Show Invoice Details in a Popup Modal -->
  <div v-if="showEditModal" ref="modalContent" class="modal-overlay">
    <div class="modal-content" @click.stop>

      <!--popup title-->
      <div class="popup-header">
        <h3>Update Invoice Payments</h3>
      </div>

      <div v-if="loadingPopup" class="spinner-container">
        <div class="spinner"></div>
      </div>

      <!-- Show Invoice Payment Details Table -->
      <table class="invoice-table" v-if="!loadingPopup">
        <thead>
        <tr>
          <th>Payment type</th>
          <th>Bank</th>
          <th>Amount (Rs)</th>
          <th>Receive Date</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(invoice, index) in invoicePaymentList" :key="index">
          <td>
            <div>{{ invoice.payment_method }}</div>
            <div v-if="invoice.cheque_no">
              (Cheque No: {{ invoice.cheque_no }})
            </div>
            <div v-if="invoice.bank_acc_no">
              (Account No: {{ invoice.bank_acc_no }})
            </div>
          </td>

          <td>{{invoice.bank|| '-' }}</td>

          <td>{{ formatNumber(invoice.amount )}} </td>
          <td>{{ formatDateTime(invoice.paid_at) }}</td>

<!--          <td>-->
<!--            <input v-if="editingRowIndex === index" v-model="invoice.paid_at" type="datetime-local" />-->
<!--            <span v-else>{{ formatDateTime(invoice.paid_at) }}</span>-->
<!--          </td>-->

          <td>
            <select
                v-if="editingRowIndex === index"
                id="status"
                v-model="invoice.status"
                class="scrollable-dropdown"
            >
              <option disabled value="">Select Status</option>
              <option v-for="status in statusList" :key="status.id" :value="status.id">
                {{ status.name }}
              </option>
            </select>

          <!-- edited due to problem -->
            <!-- <span v-else>
              {{ getStatusName(invoice.status) }}
            </span> -->

            <span :class="{
                  'status-label status-pending': invoice.status === '1',
                  'status-label status-completed': invoice.status === '2',
                  'status-label status-cancelled': invoice.status === '3',
                  'status-label status-redeemed': invoice.status === '4'
                }">
                  {{ getStatusName(invoice.status) }}
            </span>
          </td>

          <td>
            <div>
              <!-- Icons on the left, buttons on the right -->
              <div class="d-flex justify-content-between align-items-center">

                <!-- Left: Edit and Cancel Icons -->
                <div>
                  <i
                      class="fa fa-edit action-icon m-r-5"
                      :class="{ 'disabled-icon': invoice.status !== '1' || invoice.payment_method === 'Cash' }"
                      :style="{ pointerEvents: invoice.status !== '1'|| invoice.payment_method === 'Cash'  ? 'none' : 'auto' }"
                      @click="editDetails(index)"
                  ></i>

                  <i
                      class="fa fa-times-circle-o action-icon m-r-5"
                      :class="{ 'disabled-icon': invoice.status === '3' }"
                      :style="{ pointerEvents: invoice.status === '3' ? 'none' : 'auto' }"
                      @click="openCancelPopup(invoice.id, index)"
                  ></i>
                </div>

                <!-- Right: Save and Close Buttons -->
                <div v-if="editingRowIndex === index">
                  <button
                      @click="saveDetails(invoice.id,index)"
                      :disabled="saveButtonDisabled"
                      class="btn btn-success me-2"
                  >
                    <span v-if="saveButtonDisabled" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-else>Save</span>
                  </button>

                  <button
                      @click="cancelEdit()"
                      class="btn btn-danger"
                  ><i class="fa-solid fa-xmark"></i>
                  </button>
                </div>

              </div>
            </div>
          </td>

        </tr>
        <tr v-if="invoicePaymentList.length === 0">
          <td colspan="6" class="text-center">No invoice payments available</td>
        </tr>
        </tbody>
      </table>

      <!-- Show Close Button -->
      <div class="invoice-actions mt-4">
        <button @click="closeInvoicePaymentModal" class="btn button-default">Close</button>
      </div>

    </div>
  </div>

  <!-- Bottom Sheet for Cancel Invoice -->
  <div v-if="showBottomSheet" class="bottom-sheet-overlay" @click="showBottomSheet = false">
    <div class="bottom-sheet" @click.stop>
      <h3>Cancel Invoice Payment</h3>
      <label>Remark:</label>
      <textarea
          v-model="cancelRemark"
          class="bottom-sheet-textarea"
          :class="{ 'border-red': remarkError }"
          placeholder="Add your remark here..."
          maxlength="200"
          @input="validateRemark"
      ></textarea>

      <!-- Error Message -->
      <p v-if="remarkError" class="error-message">Please add a remark.</p>

      <!-- Character Counter -->
      <div class="character-counter">
        {{ cancelRemark.length }}/200
      </div>

      <div class="bottom-sheet-actions">
        <button @click="closeBottomSheet" class="btn-exit">Exit</button>
        <button @click="confirmCancel(selectedInvoiceId, selectedInvoiceIndex)" class="btn-cancel" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-else>Cancel Invoice Payment</span>
        </button>
      </div>
    </div>
  </div>

</template>

<script>

import { useToast } from 'vue-toastification';
import {useRouter} from "vue-router";
import {cancelInvoicePayment, getInvoicePaymentsByInvoiceNo, updateInvoicePaymentDetails} from "@/services/dataService";

export default {
  props: {
    showEditModal: {
      type: Boolean,
      required: true
    },
    invoice_no:{
      type:String,
      required: true
    }
  },

  data() {
    return {
      token: localStorage.getItem('token_set') || '',
      profileId: localStorage.getItem('profile_id'),
      loading: false,
      editingRowIndex: null,
      statusList: [
        { id: "1", name: "Pending" },
        { id: "2", name: "Completed" }
      ],
      invoicePaymentList:[],
      loadingPopup: false,
      showBottomSheet: false,
      cancelRemark: '',
      remarkError: false,
      selectedInvoiceId:"",
      selectedInvoiceIndex:"",
      saveButtonDisabled:false
    };
  },

  //Show messages in the toaster
  // setup() {
  //   const toast = useToast(); // Initialize the toaster
  //   return { toast };
  // },

  watch: {
    showEditModal(newVal) {
      if (newVal && this.invoice_no) {
        this.loadInvoicePaymentDetails();
      }
    },
    invoice_no(newVal) {
      if (this.showEditModal && newVal) {
        this.loadInvoicePaymentDetails();
      }
    },
    //Disable horizontal scroll when show loading
    loadingPopup(val) {
      this.toggleBodyScroll();
    },
  },


  //Functions
  methods: {

    maskAccountNumber(accountNumber) {

      const last4 = accountNumber.toString().slice(-4);
      return '••••••••' + last4;

    },

    // Format number with 2 decimal places
    formatNumber(value) {
      if (!value) return '0.00';
      return parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true, // Ensures AM/PM format
      });
    },

    // maskAccountNumber(accountNumber) {
    //   if (!accountNumber) return '';
    //
    //   const accStr = accountNumber.toString();
    //   const first4 = accStr.slice(0, 4);
    //
    //   return first4 + '-XXXXXXXXXXXX';
    // },

    //Page scroll show and hide
    toggleBodyScroll() {
      if (this.loadingPopup || this.showPopup) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },

    //Close Invoice Popup Modal
    closeInvoicePaymentModal() {
      this.$emit('close');
      this.editingRowIndex= null;
    },

    editDetails(index) {
      this.editingRowIndex = index;
    },

    async loadInvoicePaymentDetails(){
      this.loadingPopup = true;

      try {
        const response = await getInvoicePaymentsByInvoiceNo(this.invoice_no,this.token);
        this.invoicePaymentList = response.data.data || [];
        console.log('Fetched Invoice Payments:', this.bankList);
      } catch (error) {
        console.error('Error fetching Invoice Payments:', error);
      }finally {
        this.loadingPopup = false;

      }
    },

    async saveDetails(id, index) {
      const updatedInvoice = this.invoicePaymentList[index];
      this.saveButtonDisabled = true;

      const payload = {
        status: updatedInvoice.status,
      };

      console.log("index ,", id);
      console.log("Final Payload:", JSON.stringify(payload, null, 2));

      try {
        await updateInvoicePaymentDetails(id, this.token, payload);
        useToast().success("Invoice Payment Updated Successfully")
        this.loadInvoicePaymentDetails();
        this.editingRowIndex = null; // Close edit mode
      } catch (error) {
        console.error("Caught error while saving invoice:", error);
        this.saveButtonDisabled = false;
      }finally {
        this.saveButtonDisabled = false;
      }
    },

    openCancelPopup(id, index) {
      this.selectedInvoiceId = id;
      this.selectedInvoiceIndex = index;
      this.showBottomSheet = true;
    },

    cancelEdit(){
      this.editingRowIndex = null;
    },

    //Validate remark field on input change
    validateRemark() {
      if (this.cancelRemark.trim()) {
        this.remarkError = false; // Hide error if user types something
      }
    },

    //Close bottom sheet
    closeBottomSheet() {
      this.showBottomSheet = false;
      this.cancelRemark = ''; // Clear the text
      this.remarkError = false; // Reset the error flag
    },


    async confirmCancel(id, index) {

      if (!this.cancelRemark.trim()) {
        this.remarkError = true;
        return;
      }

      const cancel_status_id = "3";

      const payload = {
        payment_canceled_by: this.profileId,
        status: cancel_status_id,
        cancel_remark: this.cancelRemark
      };

      console.log("Final Payload:", JSON.stringify(payload, null, 2));


      try {
        await cancelInvoicePayment(id, this.token, payload);
        useToast().success("Invoice Payment cancelled successfully.");
        this.closeBottomSheet();
        this.loadInvoicePaymentDetails();
      } catch (error) {
        console.error("Caught error while cancelling invoice payment:", error);
      }
    },

    getStatusName(statusId) {
      const status = this.statusList.find(s => s.id === statusId);
      return status ? status.name : 'Unknown';
    },

  }
};
</script>

<style scoped>

.status-pending {
  background-color: #FFC107; /* Yellow color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-completed {
  background-color: #069E27;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
}

.status-cancelled {
  background-color: red;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
}
.status-redeemed{
  background-color: #1B6CB4;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
}


/* Bottom Sheet Styles */
.bottom-sheet-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1100;
}



.bottom-sheet {
  background: #fff;
  width: 100%; /* Make it full width */
  padding: 20px;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0;
  left: 0;
  max-width: 100%; /* Ensure it stretches across all screen sizes */
}

.bottom-sheet h3 {
  margin-bottom: 20px;
  text-align: left;
}

.bottom-sheet textarea {
  width: 100%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  margin-bottom: 10px;
}

.bottom-sheet textarea:focus {
  border-color: #1c1f23;
  outline: none;
}

.bottom-sheet-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-exit {
  background-color: #ccc;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-cancel {
  background-color: #f44336;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-exit:hover {
  background-color: #999;
}

.btn-cancel:hover {
  background-color: #d32f2f;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: -5px;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px; /* Set a height to vertically center the spinner */
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1); /* Light border */
  border-top: 4px solid #013975; /* Spinner color */
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}

.disabled-icon {
  color: #ccc !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

input{
  width: 100%; /* Ensure select takes full width of its container */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

select {
  width: 100%; /* Ensure select takes full width of its container */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="date"] {
  width: 100%; /* Ensure select takes full width of its container */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="number"] {
  width: 100%; /* Ensure select takes full width of its container */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="number"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

input[type="date"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s; /* Smooth transition for color and transform */
}

/* Hover effect for the "eye" icon */
.fa-edit:hover {
  color: #0056b3; /* Darker shade on hover */
  transform: scale(1.2); /* Slightly enlarge the icon on hover */
}

/* Active effect for the "eye" icon */
.fa-edit:active {
  transform: scale(1.1); /* Slightly shrink the icon on click */
}

.fa-times-circle-o {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s; /* Smooth transition for color and transform */
}

/* Hover effect for the "eye" icon */
.fa-times-circle-o:hover {
  color: #0056b3; /* Darker shade on hover */
  transform: scale(1.2); /* Slightly enlarge the icon on hover */
}

/* Active effect for the "eye" icon */
.fa-times-circle-o:active {
  transform: scale(1.1); /* Slightly shrink the icon on click */
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  max-width: 100%;;
  width: 90%;
  max-height: 100%; /* Set maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
}

.invoice-details div {
  flex: 1;
  margin-right: 20px;
}

.invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.invoice-table th, .invoice-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.invoice-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.invoice-actions {
  display: flex;
  justify-content: flex-end;
}

.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  margin-left: 10px;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top:20px;
  margin-bottom:20px;
}

</style>
